<mat-card>
  <mat-card-header>
    <mat-card-title translate="accounts/edition/migrate"></mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <p translate="accounts/edition/migrate/description"></p>
  </mat-card-content>

  <mat-card-actions>
    <button type="button" mat-raised-button color="primary" (click)="migrateToWhatsappCloudApi.emit()">
      {{ label }}
    </button>
  </mat-card-actions>
</mat-card>
